<template>
    <div class="d-flex flex-column">
        <template v-if="isDeviceInCartEnabled">
            <Bouton
                ref="ctaButton"
                :class="additionalClasses"
                :is-primary="isPrimary"
                :is-secondary="!isPrimary"
                :is-inverse="isInverse"
                :is-wide="isWide"
                :is-button="!isLink"
                :label="label"
                :aria-label="offerNameAccessibility"
                :data-oevent-category="trackingCategory"
                :data-oevent-action="formattedTrackingAction"
                :data-oevent-label="trackingLabel"
                @click="handleCtaClick"
            />
        </template>
        <template v-else>
            <ob1-boutons
                :class="additionalClasses"
                data-bs-toggle="modal"
                :data-bs-target="'#' + popinId"
                :is-primary="isPrimary"
                :is-secondary="!isPrimary"
                :is-inverse="isInverse"
                :is-wide="isWide"
                :is-button="!isLink"
                :label="label"
                :aria-label="offerNameAccessibility"
                :data-oevent-category="trackingCategory"
                :data-oevent-action="formattedTrackingAction"
                :data-oevent-label="trackingLabel"
            />
        </template>

        <div class="row">
            <template v-if="fromCds">
                <add-to-cart-popin-cds
                    :id="popinId"
                    ref="addToCartPopinCds"
                    :with-device-section="popinCtasDto.withDeviceSection"
                    :without-device-section="popinCtasDto.withoutDeviceSection"
                    :title="popinCtasDto.title"
                    :advantages="popinCtasDto.advantages"
                    :selected-offer-info="popinCtasDto.selectedOfferInfo"
                    :visual="popinCtasDto.visual"
                    :is-sub="isSub"
                    :offer-name="popinCtasDto.offerName"
                />
            </template>
            <template v-else>
                <with-device-popin
                    :id="popinId"
                    ref="withDevicePopin"
                    :with-device-section="popinCtasDto.withDeviceSection"
                    :without-device-section="popinCtasDto.withoutDeviceSection"
                    :title="popinCtasDto.title"
                    :description="popinCtasDto.description"
                    :visual="popinCtasDto.visual"
                />
            </template>
        </div>
    </div>
</template>
<script>
import WithDevicePopin from "./WithDevicePopin.vue";
import {CartService} from "../../../showcase/services/CartService";
import {OfferUniverse} from "../../../showcase/models/CartApiResponse";
import {MobileOffersCdsService} from "../../acquisition/vitrine/services/MobileOffersCdsService";
import Bouton from "../../../common/components/ob1/Bouton.vue";
import AddToCartPopinCds from "./AddToCartPopinCds.vue";

export default {
    name:"OfferCtaWithDevicePopin",
    components: {
        AddToCartPopinCds,
        Bouton,
        WithDevicePopin
    },
    props: {
        label: {
            type: String,
            required: true
        },
        isPrimary: {
            type: Boolean,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false
        },
        isWide: {
            type: Boolean,
            required: false
        },
        isLink:{
          type: Boolean,
            required: false
        },
        popinId: {
            type: String,
            required: true
        },
        popinCtasDto: {
            type: Object,
            required: true
        },
        //Pour le choc de simplification
        fromCds: {
            type: Boolean,
            required: false,
            default: false
        },
        //Pour le choc de simplification
        isSub: {
            type: Boolean,
            required: false,
            default: false,
        },
        offerName: {
            type: String,
            required: true
        },
        offerSeoId: {
            type: String,
            required: true,
        },
        trackingCategory: {
            type: String,
            required: true
        },
        trackingLabel: {
            type: String,
            required: true
        },
        trackingAction: {
            type: String,
            required: false,
            default: ""
        },
        additionalClasses: {
            type: String,
            default: ""
        },
    },
    computed: {
        offerNameAccessibility() {
            let offerNameAccessibilityLabel = this.offerName
                ? this.offerName
                    .replace(/Mo/g, ' méga Octet')
                    .replace(/Go/g, ' giga Octet')
                : '';
            return "Choisir le forfait " + offerNameAccessibilityLabel;
        },
        formattedTrackingAction() {
            const actionLabel = this.trackingAction ? this.trackingAction : this.label;
            return stripAccents(actionLabel).split(' ').join('_');
        },
        isDeviceInCartEnabled() {
            return this.popinCtasDto && this.popinCtasDto.deviceInCart;
        }
    },
    methods: {
         handleCtaClick() {
             this.$refs['ctaButton'].startAnimation();

             const addToCartUrl = this.fromCds ? '/api/mobile/add-to-cart' : null;

             const addToCartSuccessHandler = (response) => {
                 this.$refs['ctaButton'].stopAnimation();

                 // Émet un événement de succès vers le composant parent afin qu'il puisse
                 // actualiser les données de la page.
                 this.$emit('add-to-cart-success', {
                     offerId: this.offerSeoId,
                     response: response,
                     fromCds: this.fromCds
                 });

                 // Si on a un DTO de popin, on l'affiche après l'init du panier
                 if (this.popinCtasDto && this.popinCtasDto.deviceInCart) {
                     // Fermer la popin parente si elle existe (ex: offer-details-popin)
                     if (window.$ && this.$el) {
                         const $parentModal = window.$(this.$el).closest('.modal');
                         if ($parentModal?.length) {
                             $parentModal.modal('hide');
                         }
                     }
                     if (this.fromCds) {
                         if (this.$refs['addToCartPopinCds'] && this.$refs['addToCartPopinCds'].show) {
                             this.$refs['addToCartPopinCds'].show();
                         }
                     } else {
                         if (this.$refs['withDevicePopin'] && this.$refs['withDevicePopin'].show) {
                             this.$refs['withDevicePopin'].show();
                         }
                     }
                 } else if (response && response.redirectUrl) {
                     // fallback : redirection si pas de popin configurée
                     window.location.href = response.redirectUrl;
                 }
             }

              const addToCartFailHandler = (error) => {
                  this.$refs['ctaButton'].stopAnimation();

                  // Émet un événement d'erreur vers le composant parent afin qu'il puisse
                  // afficher un message d'erreur à l'utilisateur.
                 this.$emit('add-to-cart-error', {
                     offerId: this.offerSeoId,
                     error: error,
                     fromCds: this.fromCds
                 });
             };

              if (this.fromCds && addToCartUrl) {
                  MobileOffersCdsService.addToCartAndUpdateOffers({
                      seoId: this.offerSeoId,
                  })
                    .then(addToCartSuccessHandler)
                    .catch(addToCartFailHandler);
             } else {
                 CartService.setCart({
                     id: this.offerSeoId,
                     device: null,
                     mobileId: null,
                     universe: OfferUniverse.MOBILE
                 })
                     .then(addToCartSuccessHandler)
                     .catch(addToCartFailHandler);
             }
         }
    }
}
</script>
